import { useContext, useState } from 'react';
// Our components
import { KYXmodal } from './KYXmodal';
import { KYBModal } from './KYB/KYBModal';
import { KYXContext } from 'context/kyx-context';

export const KYX_ANALYTICS_EVENTS = {
    STEP_1: 'START_KYC',
    STEP_2: 'KYC_PHONE_NUMBER_VERIFIED',
    STEP_3: 'KYC_BASIC_INFO_VERIFIED',
    STEP_4: 'KYB_CONTACT_INFO_VERIFIED',
    STEP_5: 'KYB_TAX_INFO_VERIFIED',
    STEP_6: 'KYB_BUSINESS_DESCRIPTION_VERIFIED',
    STEP_7: 'KYB_OWNERSHIP_STATUS_VERIFIED',
    STEP_8: 'BANK_LINKING_VEFIRIED'
};

export const StartKYX = () => {
    const { isKYXModalOpen, setIsKYXModalOpen } = useContext(KYXContext);
    const [isKYBModalOpen, setIsKYBModalOpen] = useState(false);

    const handleOpenKYBModal = () => {
        setIsKYXModalOpen(false);
        setIsKYBModalOpen(true);
    };

    const handleCloseKYBModal = () => {
        setIsKYBModalOpen(false);
    };

    return (
        <>
            {isKYXModalOpen && <KYXmodal onOpenKYBModal={handleOpenKYBModal} />}
            {isKYBModalOpen && <KYBModal modalKYB={isKYBModalOpen} handleModal={handleCloseKYBModal} />}
        </>
    );
};
